import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { Import } from '../../icons';
import { getTestIds } from '../../utils/TestIds';
import { CircularLoader } from '../CircularLoader';
import { Column } from '../Layout';
import { Typography } from '../Typography/Typography';
export const GetDropzoneContentTID = (parentTestId)=>getTestIds(parentTestId);
export const DropzoneContent = (param)=>{
    let { title, hint, limit, isUploading, testId } = param;
    const { DropzoneContentTestIds: TID } = useMemo(()=>GetDropzoneContentTID(testId), [
        testId
    ]);
    if (isUploading) {
        return /*#__PURE__*/ _jsx(CircularLoader, {
            testId: TID.Parsing()
        });
    }
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 6,
        alignItems: "center",
        testId: TID.Root(),
        children: [
            /*#__PURE__*/ _jsx(Import, {}),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph1",
                children: title
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph2",
                skin: "secondary",
                children: hint
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph2",
                skin: "secondary",
                children: limit
            })
        ]
    });
};
